<script lang="ts">
  import { dailyUsage, usageLimits, subscriptionType } from '$lib/stores/subscription';
  import UsageCard from './UsageCard.svelte';
  import UsageResetTimer from './UsageResetTimer.svelte';
  import { SUBSCRIPTION_LIMITS } from '$lib/constants/subscription';
  
  $: isPremium = $subscriptionType === 'premium';
  $: isTrial = $subscriptionType === 'trial';
  $: isBeta = $subscriptionType === 'beta';
  $: limits = isPremium ? SUBSCRIPTION_LIMITS.PREMIUM
              : isTrial ? SUBSCRIPTION_LIMITS.TRIAL
              : isBeta ? SUBSCRIPTION_LIMITS.BETA
              : SUBSCRIPTION_LIMITS.FREE;
</script>

<div class="usage-container">
  <div class="usage-grid">
    <UsageCard
      title="맞춤법 검사"
      icon="✓"
      current={$dailyUsage.spellChecks}
      limit={limits.dailySpellCheckLimit}
      isUnlimited={isPremium || isTrial || isBeta}
    />

    <UsageCard
      title="AI 분석"
      icon="🤖"
      current={$dailyUsage.aiAnalyses}
      limit={limits.dailyAIAnalysisLimit}
      isUnlimited={isPremium || isTrial}
    />
  </div>
</div>

<style>
  .usage-container {
    margin-top: 16px;
  }
  
  .usage-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
  }
</style>